// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"696e7d7f","69":"ffb8aa62","99":"58ad57ed","118":"1831e2e7","143":"3ec48e08","192":"3250bd3e","295":"a3615a46","349":"f1fb055c","351":"6f57ec82","592":"f4250c97","655":"ab12faad","813":"eb145dcd","866":"a8f37948","903":"e1ecf4bc","927":"70f00039","963":"9afa6a54"}[chunkId] + ".chunk.js";
};